import React from 'react';
import { BackupConfig } from './types';

interface Props {
  config: BackupConfig;
  onConfigChange: (c: BackupConfig) => void;
}

const SFTPConfigForm: React.FC<Props> = ({ config, onConfigChange }) => {
  const sftp = config.sftp || { host: '', remotePath: '' };
  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Host
        </label>
        <input
          type="text"
          value={sftp.host}
          onChange={(e) =>
            onConfigChange({ ...config, sftp: { ...(config.sftp || {}), host: e.target.value } })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Port
        </label>
        <input
          type="number"
          value={sftp.port || 22}
          onChange={(e) =>
            onConfigChange({
              ...config,
              sftp: { ...(config.sftp || {}), port: parseInt(e.target.value || '0', 10) },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Username
        </label>
        <input
          type="text"
          value={sftp.username || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              sftp: { ...(config.sftp || {}), username: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Password
        </label>
        <input
          type="password"
          value={sftp.password || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              sftp: { ...(config.sftp || {}), password: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Private Key (optional)
        </label>
        <textarea
          rows={4}
          value={sftp.privateKey || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              sftp: { ...(config.sftp || {}), privateKey: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Remote Path
        </label>
        <input
          type="text"
          value={sftp.remotePath || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              sftp: { ...(config.sftp || {}), remotePath: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div className="md:col-span-2 text-xs text-yellow-600 dark:text-yellow-400">
        Note: SFTP backend adapter will be enabled in the next stage.
      </div>
    </div>
  );
};

export default SFTPConfigForm;
